const _LoginForm = [
  {
    text: 'email',
    id: 'userText',
    type: 'text'
  },
  {
    text: 'password',
    id: 'passwordText',
    type: 'password'
  }
];

exports.getLoginFormData = function () {
  return _LoginForm;
};
